module.exports = __webpack_public_path__ + "static/media/editPen.fc10b804.svg";